import React from "react";
import PropTypes from "prop-types";
import { Container } from "react-bootstrap";

import "./PorqueFeevale.css";

const getIdadeFeevale = () => {
	const hoje = new Date();

	const anoFundacao = 1969;
	const mesFundacao = 5; // Junho (janeiro = 0)
	const diaFundacao = 28;

	let idade = hoje.getFullYear() - anoFundacao;

	const aniversarioAindaNaoAconteceu =
		hoje.getMonth() < mesFundacao ||
		(hoje.getMonth() === mesFundacao && hoje.getDate() < diaFundacao);

	if (aniversarioAindaNaoAconteceu) {
		idade -= 1;
	}

	return idade;
};

const getValoresPadrao = () => [
	{
		numero: getIdadeFeevale(),
		texto: "anos de história",
	},
	{
		numero: "175",
		texto: "parcerias internacionais",
	},
	{
		numero: "10",
		texto: "anos entre as 5 melhores instituições privadas do Brasil",
	},
];

export default function PorqueFeevale({
	titulo = "Por que estudar na Feevale?",
	valores,
}) {
	const valoresExibidos =
		Array.isArray(valores) && valores.length > 0
			? valores
			: getValoresPadrao();

	if (valoresExibidos.length === 0) return null;

	return (
		<section className="porqueFeevale">
			<Container>
				<h2 className="porqueFeevale-titulo">{titulo}</h2>

				<div className="porqueFeevale-grid">
					{valoresExibidos.map((item, index) => (
						<div
							className="porqueFeevale-item"
							key={`${item.numero}-${index}`}
						>
							<strong>{item.numero}</strong>
							<p>{item.texto}</p>
						</div>
					))}
				</div>
			</Container>
		</section>
	);
}

PorqueFeevale.propTypes = {
	titulo: PropTypes.string,
	valores: PropTypes.arrayOf(
		PropTypes.shape({
			numero: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
				.isRequired,
			texto: PropTypes.string.isRequired,
		})
	),
};
